import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import SmartSendBookedItems from '../my-orders/booked-items';
import InTransit from '../my-orders/orders-intransit';
import SmartSendSoldItems from '../smartsend/sold-items';

export const childrenOfOrders = [
  {
    path: RoutingConstants.SmartSend,
    element: <SmartSendSoldItems />
  },
  {
    path: RoutingConstants.OrderHistory,
    element: <SmartSendBookedItems />
  },
  {
    path: RoutingConstants.InTransit,
    element: <InTransit />
  }
];

export const routesOfOrders = childrenOfOrders.map((r) => r.path);
